var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['small-prints', _vm.flowStyles && 'small-prints--flow-styles']},[_c('LeapYearSmallPrint'),_c('TCSSmallPrint'),_c('BoogoSmallPrint')],1)}
var staticRenderFns = []

export { render, staticRenderFns }